import type { FullTranslation } from "../lib/i18n"

export const BLOG_INDEX_T = {
  metaTitle: {
    FR: "Blog : méthodes de prospection B2B",
    EN: "Blog: lead generation playbooks",
  },
  metaDescription: {
    FR: "Des méthodes de prospection concrètes pour les agences marketing, les agences web, les fondateurs et les utilisateurs de HubSpot. Guides, comparatifs et cas clients.",
    EN: "Hands-on lead generation playbooks for marketing agencies, web agencies, founders and HubSpot operators. Guides, comparisons and case studies.",
  },
  badge: { FR: "Blog", EN: "Blog" },
  heading1: {
    FR: "Tout ce qu'on apprend en construisant",
    EN: "Everything we learn while building",
  },
  subhead: {
    FR: "Notes de terrain, anecdotes, et playbooks pour les équipes qu'on outille au quotidien.",
    EN: "Field notes, war stories, and playbooks for the teams we equip every day.",
  },
} satisfies FullTranslation

export const BLOG_LIST_T = {
  all: { FR: "Tous", EN: "All" },
  guide: { FR: "Guide", EN: "Guide" },
  comparatif: { FR: "Comparatif", EN: "Comparison" },
  rgpd: { FR: "RGPD", EN: "GDPR" },
  casClient: { FR: "Cas client", EN: "Case study" },
  produit: { FR: "Produit", EN: "Product" },
  empty: {
    FR: "Aucun article dans cette catégorie pour le moment.",
    EN: "No article in this category yet.",
  },
  minRead: { FR: "min de lecture", EN: "min read" },
  by: { FR: "Par", EN: "By" },
  articles: { FR: "Articles", EN: "Articles" },
  filterByCategory: {
    FR: "Filtrer les articles par catégorie",
    EN: "Filter articles by category",
  },
} satisfies FullTranslation
